import classnames from 'classnames';
import {
  CKAvatar,
  CKBox,
  CKCheckboxNext,
  CKCompanyLogo,
  CKContainerProps,
  CKLayoutGrid,
  CKLayoutGridAuto,
  CKLayoutHorizontal,
} from 'clearkit';

import { Prospect } from '~/generated/graphql';

import { Tokens } from './Tokens';

type ListItemProps = Omit<CKContainerProps, 'onSelect'> & {
  prospect: Prospect;
  isSelected: boolean;
  onSelect?: (id: string) => void;
};

const AVATAR_IMAGE_SIZE = 40;

const CompanyBlock = ({ prospect }: { prospect: Prospect }) => (
  <CKLayoutHorizontal
    alignItems="start"
    className="min-w-0 @item/list:pl-6 @item/list:border-l"
    justifyContent="start"
    wrap="nowrap"
  >
    <CKCompanyLogo size={AVATAR_IMAGE_SIZE} src={prospect.companyLogo ?? ''} />
    <div className="text-xs text-gray-600 space-y-1">
      <h3 className="font-medium text-gray-900">{prospect.companyName}</h3>
      <p>{prospect.companyDomain}</p>
      <p>{prospect.companyIndustry}</p>
      <p>{prospect.companyLocation}</p>
    </div>
  </CKLayoutHorizontal>
);

const PersonBlock = ({ prospect }: { prospect: Prospect }) => (
  <CKLayoutHorizontal alignItems="start" justifyContent="start" wrap="nowrap">
    <CKAvatar
      className="shrink-0"
      name={prospect.name}
      size={AVATAR_IMAGE_SIZE}
      src={prospect.avatar || ''}
      variant="user"
    />
    <div className="space-y-4">
      <div className="text-sm space-y-1">
        <h3 className="font-medium">{prospect.name}</h3>
        <p className="text-xs text-gray-600">{prospect.title}</p>
      </div>
      <Tokens
        hasEmail={prospect.email}
        hasLinkedIn={prospect.linkedin}
        hasPhone={prospect.phone}
        hasTwitter={prospect.twitter}
        isDealMaker={false}
      />
    </div>
  </CKLayoutHorizontal>
);

export const ListItem = ({
  className,
  prospect,
  isSelected,
  onSelect,
}: ListItemProps) => {
  const handleSelect = () => {
    onSelect?.(prospect.id);
  };

  return (
    <CKBox
      className={classnames(className, 'px-6 py-4', {
        'bg-transparent': !isSelected,
      })}
    >
      <CKLayoutGrid
        className="flex flex-wrap gap-6 @item/list:grid @item/list:gap-4"
        gridTemplateColumns="auto 1fr auto"
        gridTemplateRows="auto"
      >
        <CKCheckboxNext checked={isSelected} onChange={handleSelect} />
        <CKLayoutGridAuto
          autoRepeat="auto-fit"
          className="min-w-0"
          gap="1.5rem"
          minWidth="15rem"
        >
          <PersonBlock prospect={prospect} />
          <CompanyBlock prospect={prospect} />
        </CKLayoutGridAuto>
        <div className="w-[4rem]">{/* CRM Goes Here */}</div>
      </CKLayoutGrid>
    </CKBox>
  );
};
